import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { Tag } from 'antd';

const OrderFeature = ({ value }) => {
  const orderFeatures = useSelector(
    (state) => state.config?.data?.orderFeature,
  );
  const orderFeature = orderFeatures?.find((e) => e.value === value);
  return <Tag color={orderFeature?.color}>{orderFeature?.text}</Tag>;
};
OrderFeature.propTypes = {
  value: PropTypes.string,
};

export default OrderFeature;
